// HOC to supply default props
// Useful for making sure a component has default props when used with a HOC
export default (Component, defaultProps) => {
  return (props) => <Component {...defaultProps} {...props} />
}
